
export default {
  tokenName: 'token',
  tokenTime: 'token_time',
  DYTtoken: 'DYT-token',
  DYTuserName: 'DYT-userName'
};
